import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRootsbedrockComponent } from './simple-icons-rootsbedrock.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRootsbedrockComponent ],
    exports:      [ SimpleIconsRootsbedrockComponent ],
    bootstrap:    []
})
export class SimpleIconsRootsbedrockModule {}
